const log = {
    invalid_type: 'Il tipo di registro non è valido.',
};
export default log;
